import { Input, Select, Form } from 'antd';
import { Box, Typography } from '@mui/material';
import { validateInput } from 'pages/globals/global';
import useSolutionConfiguration from '../hooks/useSolutionConfiguration';

const SolutionConfiguration = ({ form }) => {
	const { moduleOptions, subModuleList, verticalOptions, verticalObjectList, onModuleChange } = useSolutionConfiguration({ form });

	return (
		<>
			<Form.Item noStyle name="solutionId" />

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Module
				</Typography>

				<Form.Item
					style={{ marginBottom: 0 }}
					name="module"
					rules={[
						{
							required: true,
							message: 'Module is required',
						},
					]}
				>
					<Select
						style={{ width: '100%' }}
						onChange={onModuleChange}
						placeholder="Select from the list"
						getPopupContainer={(trigger) => trigger.parentNode}
					>
						{moduleOptions?.map(({ id, name, code }) => (
							<Select.Option key={id} value={code}>
								{name}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Box>

			<Form.Item noStyle name="version" />
			<Form.Item noStyle name="createdBy" />
			<Form.Item noStyle name="modifiedBy" />
			<Form.Item noStyle name="processCode" />
			<Form.Item noStyle name="verticalName" />
			<Form.Item noStyle name="activationStatus" />

			<Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.module !== currentValues.module}>
				{() => {
					return (
						<Box mb={2}>
							<Typography fontSize={14} fontWeight={500} mb={0.5}>
								Sub Module
							</Typography>

							<Form.Item
								style={{ marginBottom: 0 }}
								name="subModule"
								rules={[
									{
										required: true,
										message: 'Sub Module is required',
									},
								]}
							>
								<Select
									style={{ width: '100%' }}
									placeholder="Select from the list"
									getPopupContainer={(trigger) => trigger.parentNode}
								>
									{subModuleList?.map(({ id, name, code }) => (
										<Select.Option key={id} value={code}>
											{name}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Box>
					);
				}}
			</Form.Item>

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Vertical
				</Typography>

				<Form.Item
					style={{ marginBottom: 0 }}
					name="vertical"
					rules={[
						{
							required: true,
							message: 'Vertical is required',
						},
					]}
				>
					<Select
						style={{ width: '100%' }}
						placeholder="Select from the list"
						getPopupContainer={(trigger) => trigger.parentNode}
						onSelect={(value) => {
							form.setFieldValue('vertical', value);
							form.setFieldValue('verticalName', verticalObjectList[value]?.name);
						}}
					>
						{verticalOptions
							?.filter(({ menu }) => menu === 'lyn-process-create')
							?.map(({ id, name, code }) => (
								<Select.Option key={id} value={code}>
									{name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
			</Box>

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Solution Name
				</Typography>

				<Form.Item
					style={{ marginBottom: 0 }}
					name="name"
					rules={[
						{
							validator: validateInput,
						},
					]}
				>
					<Input label="Solution Name" placeholder="Enter solution name" />
				</Form.Item>
			</Box>

			<Box mb={2}>
				<Typography fontSize={14} fontWeight={500} mb={0.5}>
					Short Description
				</Typography>

				<Form.Item style={{ marginBottom: 0 }} name="shortDescription">
					<Input placeholder="Enter short description" />
				</Form.Item>
			</Box>
		</>
	);
};

export default SolutionConfiguration;
